module.exports = __webpack_public_path__ + "img/13_of_Spades.svg.0f4bd307.png";